import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Card } from '@olist/united';

const CardWrapper = ({ children, disabled, isActive, ...props }) => {
  return (
    <Card
      as="button"
      disabled={disabled}
      fontSize={2}
      hasShadowOnHover
      px="20px"
      py="18px"
      variation={isActive && 'alternate'}
      width="100%"
      {...props}
    >
      {children}
    </Card>
  );
};

const StyledCardWrapper = styled(CardWrapper)`
  text-align: left;

  :enabled {
    cursor: pointer;
  }

  :disabled {
    box-shadow: none;
    cursor: not-allowed;
  }
`;

CardWrapper.propTypes = {
  children: T.node.isRequired,
  disabled: T.bool,
  isActive: T.bool,
};

CardWrapper.defaultProps = {
  disabled: false,
  isActive: false,
};

export default StyledCardWrapper;
